var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3402_17772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87391 1.63554C4.87391 1.63554 4.28862 0.218537 4.98184 0C5.78436 0 13.4374 0.349379 14.0227 0.349379C14.608 0.349379 18.5971 0.218535 19.1395 0.175385C19.1395 0.175385 25.0201 -0.293702 27.8165 0.409234C28.1901 0.605499 37.1327 5.7251 30.5312 14.5584C30.5797 14.1172 32.7105 3.71373 25.604 2.29115C23.8149 2.07818 17.165 1.29312 17.4251 5.18641C17.3435 9.11172 17.2799 18.2304 17.2799 18.2304C17.2799 18.2304 15.0355 17.4648 13.3751 19.2048C13.9286 19.6627 14.9664 20.1791 15.589 20.8751C16.0041 21.3391 16.4884 21.9887 17.2799 22.4257C17.2965 22.835 17.3172 36.6612 17.3172 36.6612C17.3172 36.6612 17.0571 39.7249 23.6696 40.2219C23.9948 40.3694 24.1415 41.547 23.6364 41.8087C22.7578 41.792 14.8557 41.4329 14.1901 41.4329C13.5246 41.4329 5.99468 41.7934 4.90574 41.76C4.64561 41.4649 4.27202 40.7953 4.88914 40.1077C5.60448 40.059 11.0838 40.0256 11.117 36.4274C11.1502 33.0422 11.1502 5.69169 11.1502 5.69169C11.1502 5.69169 11.914 2.07679 4.87391 1.63554Z",
    fill: "#00DCF5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3402_17772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9287 26.6517L34.3432 42.0745C34.3432 42.0745 45.1399 42.1887 45.9037 42.1232C46.3105 41.8449 46.4405 40.7007 46.0019 40.5044C45.3516 40.3736 43.0589 40.1119 41.8717 39.5398C40.6845 38.9677 39.222 38.2801 37.9531 36.2353C36.6843 34.1905 31.4319 26.0253 31.4319 26.0253C31.6395 25.9664 28.6798 27.807 24.9287 26.6517Z",
    fill: "#00DCF5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3402_17772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9465 19.2201C13.9465 19.2201 13.9853 19.2354 14.0545 19.2674C14.3838 19.4206 15.4035 19.9425 16.2227 20.8877C17.0681 21.6894 18.2719 22.9645 20.2879 23.1774C20.6781 23.538 23.0192 25.5006 24.4831 25.9419C28.5954 27.1814 31.4098 25.3043 31.4098 25.3043C31.4098 25.3043 40.3994 21.5753 39.3008 12.0599C39.1168 12.561 38.4983 21.5029 30.271 24.2729C29.7826 24.4038 26.661 25.2222 24.4831 24.2395C25.1667 24.3049 28.5151 24.9591 29.8808 23.9124C28.6452 23.847 27.3764 23.7816 27.3764 23.7816C27.3764 23.7816 32.644 23.4865 36.3522 17.7948C37.3927 16.0938 41.1646 8.76516 36.0921 4.38191C37.1326 7.10874 38.2811 9.96503 34.2933 16.8566C32.6025 18.9932 30.6723 21.1313 28.1582 20.9782C30.5436 19.8883 32.4503 18.3822 34.9229 13.9989C37.5242 9.05052 35.9717 0.847742 29.5169 0.700195C29.8421 1.70657 34.9229 3.26834 33.2971 10.9895C32.5167 13.7818 30.8466 17.8379 25.3618 18.9724C26.3373 18.2527 27.1176 17.0751 26.8575 16.6172C25.817 17.3368 24.7765 18.3181 21.1347 17.5331C20.0942 17.4022 17.753 17.206 17.4929 18.8415C16.3223 18.5144 15.737 18.2193 13.9479 19.2173L13.9465 19.2201Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3402_17772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.51 18.8443C18.51 18.8443 19.5076 19.891 20.3959 19.1491C20.1137 18.8875 19.6585 18.0147 18.51 18.8443Z",
    stroke: "#225987",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3402_17772",
    x: 0.553467,
    y: 0,
    width: 36.4001,
    height: 49.8087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3402_17772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3402_17772",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3402_17772",
    x: 20.9287,
    y: 26.0239,
    width: 29.3467,
    height: 24.1195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3402_17772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3402_17772",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3402_17772",
    x: 9.94653,
    y: 0.700195,
    width: 33.4475,
    height: 33.665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3402_17772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3402_17772",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3402_17772",
    x: 13.7527,
    y: 17.9946,
    width: 11.3999,
    height: 9.92017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3402_17772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3402_17772",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.958876f6e885bf82766b95c15630c15a.svg";
export { ForwardRef as ReactComponent };